export enum PermissionsEnum {
    "contacts_can_edit_view_and_comment" = "contacts_can_edit_view_and_comment",
    "contacts_can_view_and_comment" = "contacts_can_view_and_comment",
    "contacts_full_access" = "contacts_full_access",
    "contacts_no_access" = "contacts_no_access",
    "contract_control_access" = "contract_control_access",
    "contract_control_access_to_settings" = "contract_control_access_to_settings",
    "contract_control_add_new_contracts" = "contract_control_add_new_contracts",
    "contract_control_delete_documents_added_by_others" = "contract_control_delete_documents_added_by_others",
    "contract_control_edit_contracts_added_by_others" = "contract_control_edit_contracts_added_by_others",
    "restrict_access_activate_or_use_chat" = "restrict_access_activate_or_use_chat",
    "restrict_access_build_templates" = "restrict_access_build_templates",
    "restrict_access_copy_and_resend_sent_documents" = "restrict_access_copy_and_resend_sent_documents",
    "restrict_access_download_sent_documents" = "restrict_access_download_sent_documents",
    "restrict_access_edit_recipient_information_on_signing_page" = "restrict_access_edit_recipient_information_on_signing_page",
    "restrict_access_edit_role_in_groups" = "restrict_access_edit_role_in_groups",
    "restrict_access_edit_sent_document" = "restrict_access_edit_sent_document",
    "restrict_access_edit_signing_method_on_signing_page" = "restrict_access_edit_signing_method_on_signing_page",
    "restrict_access_manage_documents_via_task_management" = "restrict_access_manage_documents_via_task_management",
    "restrict_access_revoke_document" = "restrict_access_revoke_document",
    "restrict_access_send_documents_not_templates" = "restrict_access_send_documents_not_templates",
    "restrict_access_send_reminders_manually" = "restrict_access_send_reminders_manually",
    "restrict_access_upload_documents" = "restrict_access_upload_documents",
    "restrict_access_video_recording" = "restrict_access_video_recording",
    "restrict_access_delete_signed_documents"="restrict_access_delete_signed_documents",
    "settings_add_ons" = "settings_add_ons",
    "settings_api_settings" = "settings_api_settings",
    "settings_attachments" = "settings_attachments",
    "settings_branding" = "settings_branding",
    "settings_category" = "settings_category",
    "settings_general" = "settings_general",
    "settings_content_library" = "settings_content_library",
    "settings_meta_data" = "settings_meta_data",
    "settings_document_type" = "settings_document_type",
    "settings_product_library" = "settings_product_library",
    "settings_schoolsoft_schools" = "settings_schoolsoft_schools",
    "user_view" = "user_view",
    "user_manage_workspaces" = "user_manage_workspaces",
    "user_edit_info" = "user_edit_info",
    "user_edit_permissions" = "user_edit_permissions",
    "user_invite" = "user_invite",
    "user_delete" = "user_delete",
    "role_view" = "role_view",
    "role_edit" = "role_edit",
    "role_delete" = "role_delete",
    "group_view" = "group_view",
    "group_edit" = "group_edit",
    "group_delete" = "group_delete",

    "billing_and_payments_can_manage"="billing_and_payments_can_manage"
}

export interface IPermissionCategory{
    categoryName:string,
    permissions: PermissionsEnum[]
}